// extracted by mini-css-extract-plugin
export var categoryLink = "Staff-module--categoryLink--gfti2";
export var selectedCategoryLink = "Staff-module--selectedCategoryLink--7x5nT";
export var staffList = "Staff-module--staffList--3X+-H";
export var tableRow = "Staff-module--tableRow--dy79Q";